/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Tessera Backend API
 * Tessera backend application with Bearer token authentication and multi-tenant support
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  InvalidateOptions,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { BodyType, ErrorType } from '../api-instance';
import { apiInstance } from '../api-instance';
import type {
  DeletePlatformSkillPathParameters,
  ExportPlatformSkillZipPathParameters,
  GetPlatformSkillContentPathParameters,
  GetPlatformSkillPathParameters,
  ImportPlatformSkillZipParams,
  ListPlatformSkillsParams,
  TLHTTPValidationError,
  TLImportPlatformSkillZipRequest,
  TLPlatformSkillCreateRequest,
  TLPlatformSkillResponse,
  TLPlatformSkillsListResponse,
  TLPlatformSkillUpdateRequest,
  TLPreviewPlatformSkillZipImportRequest,
  TLSkillNormalizeResponse,
  TLUserSkillContentResponse,
  UpdatePlatformSkillPathParameters,
} from './tessera-backend-api.schemas';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary List Platform Skills
 */
export const listPlatformSkills = (
  params?: ListPlatformSkillsParams,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLPlatformSkillsListResponse>({ url: `/platform-skills`, method: 'GET', params, signal }, options);
};

export const getListPlatformSkillsQueryKey = (params?: ListPlatformSkillsParams) => {
  return ['platform-skills', ...(params ? [params] : [])] as const;
};

export const getListPlatformSkillsQueryOptions = <
  TData = Awaited<ReturnType<typeof listPlatformSkills>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  params?: ListPlatformSkillsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlatformSkills>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListPlatformSkillsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listPlatformSkills>>> = ({ signal }) =>
    listPlatformSkills(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPlatformSkills>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListPlatformSkillsQueryResult = NonNullable<Awaited<ReturnType<typeof listPlatformSkills>>>;
export type ListPlatformSkillsQueryError = ErrorType<TLHTTPValidationError>;

export function useListPlatformSkills<
  TData = Awaited<ReturnType<typeof listPlatformSkills>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  params: undefined | ListPlatformSkillsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlatformSkills>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPlatformSkills>>,
          TError,
          Awaited<ReturnType<typeof listPlatformSkills>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListPlatformSkills<
  TData = Awaited<ReturnType<typeof listPlatformSkills>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  params?: ListPlatformSkillsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlatformSkills>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPlatformSkills>>,
          TError,
          Awaited<ReturnType<typeof listPlatformSkills>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListPlatformSkills<
  TData = Awaited<ReturnType<typeof listPlatformSkills>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  params?: ListPlatformSkillsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlatformSkills>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Platform Skills
 */

export function useListPlatformSkills<
  TData = Awaited<ReturnType<typeof listPlatformSkills>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  params?: ListPlatformSkillsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlatformSkills>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListPlatformSkillsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Platform Skills
 */
export const prefetchListPlatformSkillsQuery = async <
  TData = Awaited<ReturnType<typeof listPlatformSkills>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  params?: ListPlatformSkillsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlatformSkills>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getListPlatformSkillsQueryOptions(params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary List Platform Skills
 */
export const invalidateListPlatformSkills = async (
  queryClient: QueryClient,
  params?: ListPlatformSkillsParams,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getListPlatformSkillsQueryKey(params) }, options);

  return queryClient;
};

/**
 * @summary Create Platform Skill
 */
export const createPlatformSkill = (
  tLPlatformSkillCreateRequest: BodyType<TLPlatformSkillCreateRequest>,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLPlatformSkillResponse>(
    {
      url: `/platform-skills`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: tLPlatformSkillCreateRequest,
      signal,
    },
    options,
  );
};

export const getCreatePlatformSkillQueryKey = (
  tLPlatformSkillCreateRequest?: BodyType<TLPlatformSkillCreateRequest>,
) => {
  return ['POST', 'platform-skills', tLPlatformSkillCreateRequest] as const;
};

export const getCreatePlatformSkillQueryOptions = <
  TData = Awaited<ReturnType<typeof createPlatformSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLPlatformSkillCreateRequest: BodyType<TLPlatformSkillCreateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof createPlatformSkill>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCreatePlatformSkillQueryKey(tLPlatformSkillCreateRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof createPlatformSkill>>> = ({ signal }) =>
    createPlatformSkill(tLPlatformSkillCreateRequest, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof createPlatformSkill>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CreatePlatformSkillQueryResult = NonNullable<Awaited<ReturnType<typeof createPlatformSkill>>>;
export type CreatePlatformSkillQueryError = ErrorType<TLHTTPValidationError>;

export function useCreatePlatformSkill<
  TData = Awaited<ReturnType<typeof createPlatformSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLPlatformSkillCreateRequest: BodyType<TLPlatformSkillCreateRequest>,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof createPlatformSkill>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof createPlatformSkill>>,
          TError,
          Awaited<ReturnType<typeof createPlatformSkill>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCreatePlatformSkill<
  TData = Awaited<ReturnType<typeof createPlatformSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLPlatformSkillCreateRequest: BodyType<TLPlatformSkillCreateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof createPlatformSkill>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof createPlatformSkill>>,
          TError,
          Awaited<ReturnType<typeof createPlatformSkill>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCreatePlatformSkill<
  TData = Awaited<ReturnType<typeof createPlatformSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLPlatformSkillCreateRequest: BodyType<TLPlatformSkillCreateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof createPlatformSkill>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Create Platform Skill
 */

export function useCreatePlatformSkill<
  TData = Awaited<ReturnType<typeof createPlatformSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLPlatformSkillCreateRequest: BodyType<TLPlatformSkillCreateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof createPlatformSkill>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCreatePlatformSkillQueryOptions(tLPlatformSkillCreateRequest, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Create Platform Skill
 */
export const prefetchCreatePlatformSkillQuery = async <
  TData = Awaited<ReturnType<typeof createPlatformSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  tLPlatformSkillCreateRequest: BodyType<TLPlatformSkillCreateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof createPlatformSkill>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getCreatePlatformSkillQueryOptions(tLPlatformSkillCreateRequest, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Create Platform Skill
 */
export const invalidateCreatePlatformSkill = async (
  queryClient: QueryClient,
  tLPlatformSkillCreateRequest: BodyType<TLPlatformSkillCreateRequest>,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getCreatePlatformSkillQueryKey(tLPlatformSkillCreateRequest) },
    options,
  );

  return queryClient;
};

/**
 * @summary Import Platform Skill Zip
 */
export const importPlatformSkillZip = (
  tLImportPlatformSkillZipRequest: BodyType<TLImportPlatformSkillZipRequest>,
  params?: ImportPlatformSkillZipParams,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  formData.append(`file`, tLImportPlatformSkillZipRequest.file);

  return apiInstance<TLPlatformSkillResponse>(
    {
      url: `/platform-skills/import`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      params,
      signal,
    },
    options,
  );
};

export const getImportPlatformSkillZipQueryKey = (
  tLImportPlatformSkillZipRequest?: BodyType<TLImportPlatformSkillZipRequest>,
  params?: ImportPlatformSkillZipParams,
) => {
  return ['POST', 'platform-skills', 'import', ...(params ? [params] : []), tLImportPlatformSkillZipRequest] as const;
};

export const getImportPlatformSkillZipQueryOptions = <
  TData = Awaited<ReturnType<typeof importPlatformSkillZip>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLImportPlatformSkillZipRequest: BodyType<TLImportPlatformSkillZipRequest>,
  params?: ImportPlatformSkillZipParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof importPlatformSkillZip>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getImportPlatformSkillZipQueryKey(tLImportPlatformSkillZipRequest, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof importPlatformSkillZip>>> = ({ signal }) =>
    importPlatformSkillZip(tLImportPlatformSkillZipRequest, params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof importPlatformSkillZip>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ImportPlatformSkillZipQueryResult = NonNullable<Awaited<ReturnType<typeof importPlatformSkillZip>>>;
export type ImportPlatformSkillZipQueryError = ErrorType<TLHTTPValidationError>;

export function useImportPlatformSkillZip<
  TData = Awaited<ReturnType<typeof importPlatformSkillZip>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLImportPlatformSkillZipRequest: BodyType<TLImportPlatformSkillZipRequest>,
  params: undefined | ImportPlatformSkillZipParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof importPlatformSkillZip>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof importPlatformSkillZip>>,
          TError,
          Awaited<ReturnType<typeof importPlatformSkillZip>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useImportPlatformSkillZip<
  TData = Awaited<ReturnType<typeof importPlatformSkillZip>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLImportPlatformSkillZipRequest: BodyType<TLImportPlatformSkillZipRequest>,
  params?: ImportPlatformSkillZipParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof importPlatformSkillZip>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof importPlatformSkillZip>>,
          TError,
          Awaited<ReturnType<typeof importPlatformSkillZip>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useImportPlatformSkillZip<
  TData = Awaited<ReturnType<typeof importPlatformSkillZip>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLImportPlatformSkillZipRequest: BodyType<TLImportPlatformSkillZipRequest>,
  params?: ImportPlatformSkillZipParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof importPlatformSkillZip>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Import Platform Skill Zip
 */

export function useImportPlatformSkillZip<
  TData = Awaited<ReturnType<typeof importPlatformSkillZip>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLImportPlatformSkillZipRequest: BodyType<TLImportPlatformSkillZipRequest>,
  params?: ImportPlatformSkillZipParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof importPlatformSkillZip>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getImportPlatformSkillZipQueryOptions(tLImportPlatformSkillZipRequest, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Import Platform Skill Zip
 */
export const prefetchImportPlatformSkillZipQuery = async <
  TData = Awaited<ReturnType<typeof importPlatformSkillZip>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  tLImportPlatformSkillZipRequest: BodyType<TLImportPlatformSkillZipRequest>,
  params?: ImportPlatformSkillZipParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof importPlatformSkillZip>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getImportPlatformSkillZipQueryOptions(tLImportPlatformSkillZipRequest, params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Import Platform Skill Zip
 */
export const invalidateImportPlatformSkillZip = async (
  queryClient: QueryClient,
  tLImportPlatformSkillZipRequest: BodyType<TLImportPlatformSkillZipRequest>,
  params?: ImportPlatformSkillZipParams,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getImportPlatformSkillZipQueryKey(tLImportPlatformSkillZipRequest, params) },
    options,
  );

  return queryClient;
};

/**
 * @summary Preview Platform Skill Zip
 */
export const previewPlatformSkillZip = (
  tLPreviewPlatformSkillZipImportRequest: BodyType<TLPreviewPlatformSkillZipImportRequest>,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  formData.append(`file`, tLPreviewPlatformSkillZipImportRequest.file);

  return apiInstance<TLSkillNormalizeResponse>(
    {
      url: `/platform-skills/import/preview`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      signal,
    },
    options,
  );
};

export const getPreviewPlatformSkillZipQueryKey = (
  tLPreviewPlatformSkillZipImportRequest?: BodyType<TLPreviewPlatformSkillZipImportRequest>,
) => {
  return ['POST', 'platform-skills', 'import', 'preview', tLPreviewPlatformSkillZipImportRequest] as const;
};

export const getPreviewPlatformSkillZipQueryOptions = <
  TData = Awaited<ReturnType<typeof previewPlatformSkillZip>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLPreviewPlatformSkillZipImportRequest: BodyType<TLPreviewPlatformSkillZipImportRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof previewPlatformSkillZip>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPreviewPlatformSkillZipQueryKey(tLPreviewPlatformSkillZipImportRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof previewPlatformSkillZip>>> = ({ signal }) =>
    previewPlatformSkillZip(tLPreviewPlatformSkillZipImportRequest, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof previewPlatformSkillZip>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PreviewPlatformSkillZipQueryResult = NonNullable<Awaited<ReturnType<typeof previewPlatformSkillZip>>>;
export type PreviewPlatformSkillZipQueryError = ErrorType<TLHTTPValidationError>;

export function usePreviewPlatformSkillZip<
  TData = Awaited<ReturnType<typeof previewPlatformSkillZip>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLPreviewPlatformSkillZipImportRequest: BodyType<TLPreviewPlatformSkillZipImportRequest>,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof previewPlatformSkillZip>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewPlatformSkillZip>>,
          TError,
          Awaited<ReturnType<typeof previewPlatformSkillZip>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePreviewPlatformSkillZip<
  TData = Awaited<ReturnType<typeof previewPlatformSkillZip>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLPreviewPlatformSkillZipImportRequest: BodyType<TLPreviewPlatformSkillZipImportRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof previewPlatformSkillZip>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewPlatformSkillZip>>,
          TError,
          Awaited<ReturnType<typeof previewPlatformSkillZip>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePreviewPlatformSkillZip<
  TData = Awaited<ReturnType<typeof previewPlatformSkillZip>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLPreviewPlatformSkillZipImportRequest: BodyType<TLPreviewPlatformSkillZipImportRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof previewPlatformSkillZip>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Preview Platform Skill Zip
 */

export function usePreviewPlatformSkillZip<
  TData = Awaited<ReturnType<typeof previewPlatformSkillZip>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLPreviewPlatformSkillZipImportRequest: BodyType<TLPreviewPlatformSkillZipImportRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof previewPlatformSkillZip>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPreviewPlatformSkillZipQueryOptions(tLPreviewPlatformSkillZipImportRequest, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Preview Platform Skill Zip
 */
export const prefetchPreviewPlatformSkillZipQuery = async <
  TData = Awaited<ReturnType<typeof previewPlatformSkillZip>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  tLPreviewPlatformSkillZipImportRequest: BodyType<TLPreviewPlatformSkillZipImportRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof previewPlatformSkillZip>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getPreviewPlatformSkillZipQueryOptions(tLPreviewPlatformSkillZipImportRequest, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Preview Platform Skill Zip
 */
export const invalidatePreviewPlatformSkillZip = async (
  queryClient: QueryClient,
  tLPreviewPlatformSkillZipImportRequest: BodyType<TLPreviewPlatformSkillZipImportRequest>,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getPreviewPlatformSkillZipQueryKey(tLPreviewPlatformSkillZipImportRequest) },
    options,
  );

  return queryClient;
};

/**
 * @summary Delete Platform Skill
 */
export const deletePlatformSkill = (
  { slug }: DeletePlatformSkillPathParameters,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<void>({ url: `/platform-skills/${slug}`, method: 'DELETE', signal }, options);
};

export const getDeletePlatformSkillQueryKey = ({ slug }: DeletePlatformSkillPathParameters) => {
  return ['DELETE', 'platform-skills', slug] as const;
};

export const getDeletePlatformSkillQueryOptions = <
  TData = Awaited<ReturnType<typeof deletePlatformSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { slug }: DeletePlatformSkillPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof deletePlatformSkill>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDeletePlatformSkillQueryKey({ slug });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof deletePlatformSkill>>> = ({ signal }) =>
    deletePlatformSkill({ slug }, requestOptions, signal);

  return { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof deletePlatformSkill>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DeletePlatformSkillQueryResult = NonNullable<Awaited<ReturnType<typeof deletePlatformSkill>>>;
export type DeletePlatformSkillQueryError = ErrorType<TLHTTPValidationError>;

export function useDeletePlatformSkill<
  TData = Awaited<ReturnType<typeof deletePlatformSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: DeletePlatformSkillPathParameters,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof deletePlatformSkill>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deletePlatformSkill>>,
          TError,
          Awaited<ReturnType<typeof deletePlatformSkill>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDeletePlatformSkill<
  TData = Awaited<ReturnType<typeof deletePlatformSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: DeletePlatformSkillPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof deletePlatformSkill>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deletePlatformSkill>>,
          TError,
          Awaited<ReturnType<typeof deletePlatformSkill>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDeletePlatformSkill<
  TData = Awaited<ReturnType<typeof deletePlatformSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: DeletePlatformSkillPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof deletePlatformSkill>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Delete Platform Skill
 */

export function useDeletePlatformSkill<
  TData = Awaited<ReturnType<typeof deletePlatformSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { slug }: DeletePlatformSkillPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof deletePlatformSkill>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDeletePlatformSkillQueryOptions({ slug }, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Delete Platform Skill
 */
export const prefetchDeletePlatformSkillQuery = async <
  TData = Awaited<ReturnType<typeof deletePlatformSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { slug }: DeletePlatformSkillPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof deletePlatformSkill>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getDeletePlatformSkillQueryOptions({ slug }, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Delete Platform Skill
 */
export const invalidateDeletePlatformSkill = async (
  queryClient: QueryClient,
  { slug }: DeletePlatformSkillPathParameters,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getDeletePlatformSkillQueryKey({ slug }) }, options);

  return queryClient;
};

/**
 * @summary Get Platform Skill
 */
export const getPlatformSkill = (
  { slug }: GetPlatformSkillPathParameters,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLPlatformSkillResponse>({ url: `/platform-skills/${slug}`, method: 'GET', signal }, options);
};

export const getGetPlatformSkillQueryKey = ({ slug }: GetPlatformSkillPathParameters) => {
  return ['platform-skills', slug] as const;
};

export const getGetPlatformSkillQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlatformSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { slug }: GetPlatformSkillPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformSkill>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPlatformSkillQueryKey({ slug });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformSkill>>> = ({ signal }) =>
    getPlatformSkill({ slug }, requestOptions, signal);

  return { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlatformSkill>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPlatformSkillQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformSkill>>>;
export type GetPlatformSkillQueryError = ErrorType<TLHTTPValidationError>;

export function useGetPlatformSkill<
  TData = Awaited<ReturnType<typeof getPlatformSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: GetPlatformSkillPathParameters,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformSkill>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformSkill>>,
          TError,
          Awaited<ReturnType<typeof getPlatformSkill>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPlatformSkill<
  TData = Awaited<ReturnType<typeof getPlatformSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: GetPlatformSkillPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformSkill>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformSkill>>,
          TError,
          Awaited<ReturnType<typeof getPlatformSkill>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPlatformSkill<
  TData = Awaited<ReturnType<typeof getPlatformSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: GetPlatformSkillPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformSkill>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Platform Skill
 */

export function useGetPlatformSkill<
  TData = Awaited<ReturnType<typeof getPlatformSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { slug }: GetPlatformSkillPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformSkill>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPlatformSkillQueryOptions({ slug }, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Platform Skill
 */
export const prefetchGetPlatformSkillQuery = async <
  TData = Awaited<ReturnType<typeof getPlatformSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { slug }: GetPlatformSkillPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformSkill>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetPlatformSkillQueryOptions({ slug }, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Get Platform Skill
 */
export const invalidateGetPlatformSkill = async (
  queryClient: QueryClient,
  { slug }: GetPlatformSkillPathParameters,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getGetPlatformSkillQueryKey({ slug }) }, options);

  return queryClient;
};

/**
 * @summary Update Platform Skill
 */
export const updatePlatformSkill = (
  { slug }: UpdatePlatformSkillPathParameters,
  tLPlatformSkillUpdateRequest: BodyType<TLPlatformSkillUpdateRequest>,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLPlatformSkillResponse>(
    {
      url: `/platform-skills/${slug}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: tLPlatformSkillUpdateRequest,
      signal,
    },
    options,
  );
};

export const getUpdatePlatformSkillQueryKey = (
  { slug }: UpdatePlatformSkillPathParameters,
  tLPlatformSkillUpdateRequest?: BodyType<TLPlatformSkillUpdateRequest>,
) => {
  return ['PUT', 'platform-skills', slug, tLPlatformSkillUpdateRequest] as const;
};

export const getUpdatePlatformSkillQueryOptions = <
  TData = Awaited<ReturnType<typeof updatePlatformSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { slug }: UpdatePlatformSkillPathParameters,
  tLPlatformSkillUpdateRequest: BodyType<TLPlatformSkillUpdateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof updatePlatformSkill>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUpdatePlatformSkillQueryKey({ slug }, tLPlatformSkillUpdateRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof updatePlatformSkill>>> = ({ signal }) =>
    updatePlatformSkill({ slug }, tLPlatformSkillUpdateRequest, requestOptions, signal);

  return { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof updatePlatformSkill>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type UpdatePlatformSkillQueryResult = NonNullable<Awaited<ReturnType<typeof updatePlatformSkill>>>;
export type UpdatePlatformSkillQueryError = ErrorType<TLHTTPValidationError>;

export function useUpdatePlatformSkill<
  TData = Awaited<ReturnType<typeof updatePlatformSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: UpdatePlatformSkillPathParameters,
  tLPlatformSkillUpdateRequest: BodyType<TLPlatformSkillUpdateRequest>,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof updatePlatformSkill>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof updatePlatformSkill>>,
          TError,
          Awaited<ReturnType<typeof updatePlatformSkill>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useUpdatePlatformSkill<
  TData = Awaited<ReturnType<typeof updatePlatformSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: UpdatePlatformSkillPathParameters,
  tLPlatformSkillUpdateRequest: BodyType<TLPlatformSkillUpdateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof updatePlatformSkill>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof updatePlatformSkill>>,
          TError,
          Awaited<ReturnType<typeof updatePlatformSkill>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useUpdatePlatformSkill<
  TData = Awaited<ReturnType<typeof updatePlatformSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: UpdatePlatformSkillPathParameters,
  tLPlatformSkillUpdateRequest: BodyType<TLPlatformSkillUpdateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof updatePlatformSkill>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Update Platform Skill
 */

export function useUpdatePlatformSkill<
  TData = Awaited<ReturnType<typeof updatePlatformSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { slug }: UpdatePlatformSkillPathParameters,
  tLPlatformSkillUpdateRequest: BodyType<TLPlatformSkillUpdateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof updatePlatformSkill>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getUpdatePlatformSkillQueryOptions({ slug }, tLPlatformSkillUpdateRequest, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Update Platform Skill
 */
export const prefetchUpdatePlatformSkillQuery = async <
  TData = Awaited<ReturnType<typeof updatePlatformSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { slug }: UpdatePlatformSkillPathParameters,
  tLPlatformSkillUpdateRequest: BodyType<TLPlatformSkillUpdateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof updatePlatformSkill>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getUpdatePlatformSkillQueryOptions({ slug }, tLPlatformSkillUpdateRequest, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Update Platform Skill
 */
export const invalidateUpdatePlatformSkill = async (
  queryClient: QueryClient,
  { slug }: UpdatePlatformSkillPathParameters,
  tLPlatformSkillUpdateRequest: BodyType<TLPlatformSkillUpdateRequest>,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getUpdatePlatformSkillQueryKey({ slug }, tLPlatformSkillUpdateRequest) },
    options,
  );

  return queryClient;
};

/**
 * @summary Get Platform Skill Content
 */
export const getPlatformSkillContent = (
  { slug }: GetPlatformSkillContentPathParameters,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLUserSkillContentResponse>(
    { url: `/platform-skills/${slug}/content`, method: 'GET', signal },
    options,
  );
};

export const getGetPlatformSkillContentQueryKey = ({ slug }: GetPlatformSkillContentPathParameters) => {
  return ['platform-skills', slug, 'content'] as const;
};

export const getGetPlatformSkillContentQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlatformSkillContent>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { slug }: GetPlatformSkillContentPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformSkillContent>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPlatformSkillContentQueryKey({ slug });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformSkillContent>>> = ({ signal }) =>
    getPlatformSkillContent({ slug }, requestOptions, signal);

  return { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlatformSkillContent>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPlatformSkillContentQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformSkillContent>>>;
export type GetPlatformSkillContentQueryError = ErrorType<TLHTTPValidationError>;

export function useGetPlatformSkillContent<
  TData = Awaited<ReturnType<typeof getPlatformSkillContent>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: GetPlatformSkillContentPathParameters,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformSkillContent>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformSkillContent>>,
          TError,
          Awaited<ReturnType<typeof getPlatformSkillContent>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPlatformSkillContent<
  TData = Awaited<ReturnType<typeof getPlatformSkillContent>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: GetPlatformSkillContentPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformSkillContent>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformSkillContent>>,
          TError,
          Awaited<ReturnType<typeof getPlatformSkillContent>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPlatformSkillContent<
  TData = Awaited<ReturnType<typeof getPlatformSkillContent>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: GetPlatformSkillContentPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformSkillContent>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Platform Skill Content
 */

export function useGetPlatformSkillContent<
  TData = Awaited<ReturnType<typeof getPlatformSkillContent>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { slug }: GetPlatformSkillContentPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformSkillContent>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPlatformSkillContentQueryOptions({ slug }, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Platform Skill Content
 */
export const prefetchGetPlatformSkillContentQuery = async <
  TData = Awaited<ReturnType<typeof getPlatformSkillContent>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { slug }: GetPlatformSkillContentPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformSkillContent>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetPlatformSkillContentQueryOptions({ slug }, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Get Platform Skill Content
 */
export const invalidateGetPlatformSkillContent = async (
  queryClient: QueryClient,
  { slug }: GetPlatformSkillContentPathParameters,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getGetPlatformSkillContentQueryKey({ slug }) }, options);

  return queryClient;
};

/**
 * @summary Export Platform Skill Zip
 */
export const exportPlatformSkillZip = (
  { slug }: ExportPlatformSkillZipPathParameters,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<unknown>({ url: `/platform-skills/${slug}/export`, method: 'GET', signal }, options);
};

export const getExportPlatformSkillZipQueryKey = ({ slug }: ExportPlatformSkillZipPathParameters) => {
  return ['platform-skills', slug, 'export'] as const;
};

export const getExportPlatformSkillZipQueryOptions = <
  TData = Awaited<ReturnType<typeof exportPlatformSkillZip>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { slug }: ExportPlatformSkillZipPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof exportPlatformSkillZip>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getExportPlatformSkillZipQueryKey({ slug });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof exportPlatformSkillZip>>> = ({ signal }) =>
    exportPlatformSkillZip({ slug }, requestOptions, signal);

  return { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof exportPlatformSkillZip>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExportPlatformSkillZipQueryResult = NonNullable<Awaited<ReturnType<typeof exportPlatformSkillZip>>>;
export type ExportPlatformSkillZipQueryError = ErrorType<TLHTTPValidationError>;

export function useExportPlatformSkillZip<
  TData = Awaited<ReturnType<typeof exportPlatformSkillZip>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: ExportPlatformSkillZipPathParameters,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof exportPlatformSkillZip>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportPlatformSkillZip>>,
          TError,
          Awaited<ReturnType<typeof exportPlatformSkillZip>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useExportPlatformSkillZip<
  TData = Awaited<ReturnType<typeof exportPlatformSkillZip>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: ExportPlatformSkillZipPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof exportPlatformSkillZip>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportPlatformSkillZip>>,
          TError,
          Awaited<ReturnType<typeof exportPlatformSkillZip>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useExportPlatformSkillZip<
  TData = Awaited<ReturnType<typeof exportPlatformSkillZip>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: ExportPlatformSkillZipPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof exportPlatformSkillZip>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Export Platform Skill Zip
 */

export function useExportPlatformSkillZip<
  TData = Awaited<ReturnType<typeof exportPlatformSkillZip>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { slug }: ExportPlatformSkillZipPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof exportPlatformSkillZip>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getExportPlatformSkillZipQueryOptions({ slug }, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Export Platform Skill Zip
 */
export const prefetchExportPlatformSkillZipQuery = async <
  TData = Awaited<ReturnType<typeof exportPlatformSkillZip>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { slug }: ExportPlatformSkillZipPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof exportPlatformSkillZip>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getExportPlatformSkillZipQueryOptions({ slug }, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Export Platform Skill Zip
 */
export const invalidateExportPlatformSkillZip = async (
  queryClient: QueryClient,
  { slug }: ExportPlatformSkillZipPathParameters,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getExportPlatformSkillZipQueryKey({ slug }) }, options);

  return queryClient;
};
